export enum BroadcastChannels {
  DESKTOP = 'desktop',
  AUTH = 'auth',
  NOTIFICATIONS = 'notifications'
}
